import useAuth from "../../hooks/useAuth";
import useDeceased from "../../hooks/useDeceased";
import {useParams} from "react-router-dom";
import {updateDeceasedSignatory} from "../../api/pro/deceasedReq";
import {useEffect, useState, useCallback, useRef} from "react";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList, validateFormInput} from "../../helper/tools";
import FormButtons from "../../components/common/FormButtons";

export default function FormSignatory({
    apiDeceasedInfos,
    setShowModal,
    registerSubmitFunction,
    liveIsAdminFilled,
    liveIsCorrespondentFilled,
    noSubmitButton = false
}) {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const { deceasedInfos } = useDeceased();
    // En dehors du wizard (modales d'édition), gestionnaire et correspondant sont déjà enregistrés
    // avant même d'ouvrir ce formulaire : liveIsAdminFilled/liveIsCorrespondentFilled ne sont alors
    // pas fournis, on les considère donc comme renseignés par défaut.
    const isAdminFilled = liveIsAdminFilled !== undefined ? liveIsAdminFilled : true;
    const isCorrespondentFilled = liveIsCorrespondentFilled !== undefined ? liveIsCorrespondentFilled : true;
    const isChoiceReady = isAdminFilled && isCorrespondentFilled;
    // Pas de valeur existante (ni 0 ni 1) : cocher "Le gestionnaire" par défaut une fois la
    // proposition affichée (?? préserve une valeur déjà enregistrée, y compris 0).
    const [values, setValues] = useState({
        gestionnaireSignatory: deceasedInfos?.gestionnaireSignatory ?? 1
    });
    const fieldsetRef = useRef();

    useEffect(() => {
        setValues({
            gestionnaireSignatory: deceasedInfos?.gestionnaireSignatory ?? 1
        })
    }, [ deceasedInfos ]);


    const onChange = (e) => {
        setValues({...values, [e.target.name]: e.target.value})
        validateFormInput(e)
    }

    const handleRemoveModal = () => {
        if (setShowModal) {
            setShowModal(false);
        }
    }

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault()

        // Utiliser fieldsetRef pour la validation
        if (!checkRequiredFields(fieldsetRef.current)) {
            return;
        }
        let body = {
            deceasedId: id,
            gestionnaireSignatory: values?.gestionnaireSignatory
        }
        await updateDeceasedSignatory(token, body)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    apiDeceasedInfos();

                    if (!noSubmitButton && setShowModal) {
                        setShowModal(false);
                    }
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }, [values, token, id, noSubmitButton, apiDeceasedInfos, setShowModal]);

    useEffect(() => {
        if (registerSubmitFunction) {
            registerSubmitFunction(handleSubmit);
        }
    }, [registerSubmitFunction, handleSubmit]);

    const content = (
        <fieldset ref={fieldsetRef}>
            <legend>Informations sur le signataire</legend>
            { !isChoiceReady &&
                <p className="info-message">Veuillez d'abord renseigner le gestionnaire et le correspondant.</p>
            }
            { isChoiceReady &&
                <div className="form-group">
                    <div className="form-input">
                        <label htmlFor="gestionnaireSignatory" className="required">Le signataire des courriers est</label>
                        <input type="radio" name="gestionnaireSignatory" id="gestionnaireSignatory1" value={1} required checked={values?.gestionnaireSignatory == 1} onChange={onChange}/><label htmlFor="gestionnaireSignatory1">Le gestionnaire</label>
                        <input type="radio" name="gestionnaireSignatory" id="gestionnaireSignatory0" value={0} checked={values?.gestionnaireSignatory == 0} onChange={onChange}/><label htmlFor="gestionnaireSignatory0">Le correspondant</label>
                    </div>
                </div>
            }

            <div className="errors"></div>

            {!noSubmitButton && <FormButtons handleRemoveModal={handleRemoveModal}/>}
        </fieldset>
    );

    // Si noSubmitButton est false (mode modal), wrapper dans un form
    // Si noSubmitButton est true (mode inline), pas de wrapper form (sera dans le form parent)
    return noSubmitButton ? content : (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            {content}
        </form>
    );
}